<!--
 * @Author: Latte
 * @Date: 2021-10-14 14:37:18
 * @LAstEditors: Latte
 * @LastEditTime: 2021-10-20 08:56:01
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\CarouselManagement\ForumGroup.vue
-->
<template>
  <div>
    <!-- 顶部栏 -->
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>


      </div>
      <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click.stop="handleAdd()"
      >
        新增图片
      </el-button>
    </div>
    <div>
      <el-select v-model="curForumGroup" filterable clearable @change="curSelectOptionChange()">
        <el-option :value="0" label="首页" :key="0"></el-option>
        <el-option v-for="item in forumGroupList" :value="item.forumGroupId" :label="item.groupName"
                   :key="item.forumGroupId"></el-option>
      </el-select>

      <el-select style="padding-left: 20px" v-model="curIsDeletedOption" clearable @change="curSelectOptionChange()">
        <el-option v-for="item in isDeletedOptions" :value="item.value" :label="item.label"
                   :key="item.value"></el-option>
      </el-select>
    </div>
    <div style="padding:10px"></div>
    <!-- 内容 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
        border
    >
      <el-table-column label="#" prop="forumGroupSliderImageId" align="center" width="100"></el-table-column>
      <el-table-column label="创建日期" prop="CreateTime" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.createTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column
          label="活动主题"
          align="center"
          prop="title"
          show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="宣传图片" align="center" prop="ImageURL">
        <template slot-scope="scope">
          <el-image
              style="height: 100px"
              fit="scale-down"
              :src="getImageUrl(scope.row.imageUrl) "
              :preview-src-list="[getImageUrl(scope.row.imageUrl) ]"
              lazy
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
          label="资源"
          align="center"
          prop="linkUrl"
          show-overflow-tooltip
      >
        <template #default="scope">
          <el-button type="text" @click="handleClickResource(scope.row)">{{ getResourceDesp(scope.row) }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
          label="发布人员"
          align="center"
          prop="CreateUserName"
          width="150"
      >
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column
          label="浏览量"
          align="center"
          prop="pageViews"
          width="100"
      ></el-table-column>
      <el-table-column label="所属群组" align="center" show-overflow-tooltip>
        <template #default="scope">
          {{ getGroupName(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column v-if="userDataType.length > 0" label="所属领域" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.row.userDataType | userDataTypeTransform }}
        </template>
      </el-table-column>
      <el-table-column label="启用状态" align="center" width="180">
        <template #default="scope">
          <el-switch v-model="scope.row.isEnabled" active-text="启用" inactive-text="未启用"
                     @change="handleSwitch(scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button
              size="small"
              type="primary"
              @click.stop="handleUpdate(scope.row)"
          >
            编辑
          </el-button>
          <el-button
              size="small"
              :type="scope.row.isDeleted ? 'warning' : 'danger'"
              @click.stop="handleRemove(scope.row)"
          >
            {{ scope.row.isDeleted ? '恢复' : '删除' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
        v-show="totalCount > pageSize"
        background
        :total="totalCount"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="currentChange"
    />

    <el-dialog
        :title="
        dialogStatus === 'create'
          ? '添加超人圈群组轮播图'
          : '修改超人圈群组轮播图'
      "
        :visible.sync="dialogVisible"
        width="60%"
    >
      <el-form :model="temp" ref="forumGroupSlideImageForm" v-loading="uploadLoading">
        <el-form-item
            label="图片标题"
            label-width="90px"
            prop="title"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="temp.title" maxlength="100" show-word-limit/>
        </el-form-item>
        <el-form-item label="选择图片" label-width="90px">
          <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="change2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(temp.imageUrl)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="90px" label="是否启用">
          <el-switch active-text="启用" inactive-text="未启用" v-model="temp.isEnabled"></el-switch>
        </el-form-item>
        <el-form-item label="链接类型" label-width="90px" prop="linkType"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
          <el-select v-model="temp.linkType">
            <el-option label="URL地址" :value="1"></el-option>
            <el-option label="直播信息" :value="2"></el-option>
            <el-option label="往期回顾" :value="3"></el-option>
            <el-option label="视频课程" :value="4"></el-option>
            <el-option label="超人圈话题" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="90px"
                      v-if="temp.linkType === 2 || temp.linkType === 3 || temp.linkType === 4 || temp.linkType === 5"
                      label="资源id"
                      prop="bindId"
                      :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
          <el-input-number v-model="temp.bindId"></el-input-number>
        </el-form-item>
        <el-form-item
            v-else
            label="页面地址"
            label-width="90px"
            prop="linkUrl"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="temp.linkUrl"/>
          <div class="el-upload__tip" style="color: #aaa">
            页面需要向开发人员定制，发布后将页面地址填写在此处
          </div>
        </el-form-item>
        <el-form-item label="目标群组" label-width="90px">
          <el-select v-model="temp.forumGroupIdList" multiple filterable clearable>
            <!-- TODO -->
            <el-option :value="0" label="首页" :key="0"></el-option>
            <el-option v-for="item in forumGroupList" :value="item.forumGroupId" :key="item.forumGroupId"
                       :label="item.groupName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            v-if="userDataType.length > 0"
            label="所属领域"
            label-width="90px"
            prop="userDataType"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-select v-model="temp.userDataType" style="width: 100%">
            <el-option v-for="item in userDataType" :value="item.value" :label="item.name"
                       :key="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">
          取 消
        </el-button>
        <el-button
            size="small"
            type="primary"
            @click="dialogStatus === 'create' ? createPitcure() : updatePitcure()"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getForumGroupSliderImageList,
  addForumGroupSliderImage,
  deleteForumGroupSliderImageOrBack,
  updateForumGroupSliderImage
} from "@/api/CarouselManagement/CarouselManagement";
import {getUserType} from "@/utils/userutil";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import UserInfo from "@/components/UserInfo/UserInfo";
import {handleRes} from "@/utils/handleRes";
import {getAllForumGroupList} from "@/api/ultrasonic";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {isVaild} from "@/utils/validate";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {deepClone} from "@/utils";
import {copy2Clipboard} from "@/utils/clipboard";
import {
  go2ForumGroupSlideImageDetail,
  go2LiveDetail,
  go2LiveReviewDetail,
  go2LiveVideoDetail,
  go2UltrasonicDetail
} from "@/utils/UIHelper";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

export default {
  components: {UserInfo},
  data() {
    return {
      navigationKey: "slideImageForumGroup",

      loading: false, // 加载开关
      searchValue: "",
      uploadLoading: false, // 上传加载开关
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      tableData: [],
      dialogVisible: false,
      dialogStatus: "",
      temp: {},
      userDataType: [],
      forumGroupList: [],//全部超人圈群组数据，用于发表时选择
      curForumGroup: "",
      uploadCoverFile: null,
      uploadCoverFileURL: "",

      curIsDeletedOption: "",
      isDeletedOptions: [
        {
          value: "", label: "全部"
        },
        {
          value: false, label: "未删除"
        },
        {
          value: true, label: "已删除"
        },
      ],
    };
  },
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.searchValue = navigationObj.searchValue
    this.currentPage = navigationObj.currentPage
    this.curForumGroup = navigationObj.curForumGroup
    this.curIsDeletedOption = navigationObj.curIsDeletedOption
    if (!isVaild(this.curIsDeletedOption)) {
      this.curIsDeletedOption = false;
    }

    this.getForumGroupSlideImageList();
    this.userDataType = getUserType()
    this.getAllForumGroupList()
  },
  methods: {
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    getAllForumGroupList() {
      getAllForumGroupList({
        pageSize: 0
      }).then(res => {
        handleRes(res, () => {
          this.forumGroupList = res.data.rows
        })
      })
    },
    search() {
      this.refreshCurrentList()
    },
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    /**
     * 刷新列表
     */
    refreshCurrentList() {
      this.currentPage = 1;
      this.getForumGroupSlideImageList();
    },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getForumGroupSlideImageList();
    },
    curSelectOptionChange() {
      this.refreshCurrentList()
    },
    /**
     * 获取直播轮播图
     */
    getForumGroupSlideImageList() {
      this.loading = true;
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyWord: this.searchValue,
        forumGroupId: isVaild(this.curForumGroup) ? this.curForumGroup : -1
      };
      if (isVaild(this.curIsDeletedOption)) {
        params.where = [
          {
            "field": "isDeleted",
            "value": this.curIsDeletedOption,
            "op": "equal"
          }
        ]
      }

      setNavigationItemWithObj(this.navigationKey, {
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        curForumGroup: this.curForumGroup,
        curIsDeletedOption: this.curIsDeletedOption
      })

      getForumGroupSliderImageList(params).then((res) => {
        handleRes(res, () => {
          this.totalCount = res.data.total;
          this.tableData = res.data.rows;
        })
        this.loading = false;
      });
    },
    getGroupName(entity) {
      let res = ""
      if (entity.forumGroupVoList != null && entity.forumGroupVoList.length > 0) {
        res = entity.forumGroupVoList.map(entity => {
          return entity.groupName
        }).reduce((pre, cur) => {
          return pre + "，" + cur;
        })
      }
      return res
    },
    getResourceDesp(entity) {
      let res = ""
      switch (entity.linkType) {
        case 1:
          res = `Url:${entity?.linkUrl}`
          break;
        case 2:
          res = `直播： ${entity.bindResourceObj?.liveTitle}`
          break;
        case 3:
          res = `往期回顾： ${entity.bindResourceObj?.liveTitle}`
          break;
        case 4:
          res = `视频课程： ${entity.bindResourceObj?.videoName}`
          break;
        case 5:
          res = `超人圈话题： ${entity.bindResourceObj?.customTitle}`
          break;
      }
      return res
    },
    handleClickResource(entity) {
      switch (entity.linkType) {
        case 1://url
          copy2Clipboard(entity?.linkUrl)
          this.$message('已复制链接地址')
          break;
        case 2://直播
          go2LiveDetail(this, entity.bindResourceObj?.liveTitle)
          break;
        case 3://往期回顾
          go2LiveReviewDetail(this, entity?.bindId)
          break;
        case 4://视频课程
          go2LiveVideoDetail(this, entity?.bindId,)
          break;
        case 5://超人圈帖子
          go2UltrasonicDetail(this,entity?.bindId)
          break
      }
    },
    /**
     * 启用/停用直播轮播图
     */
    handleSwitch(row) {
      const params = {
        forumGroupSliderImageId: row.forumGroupSliderImageId,
        isEnabled: row.isEnabled
      };
      updateForumGroupSliderImage(params).then((res) => {
        handleRes(res, () => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getForumGroupSlideImageList();
        })
      });
    },
    resetTemp() {
      this.temp = {
        userDataType: 0,
      };
    },
    /**
     * @description: 打开添加图片对话框
     * @param {*}
     * @return {*}
     */
    handleAdd() {
      this.resetTemp();
      this.dialogStatus = "create";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["forumGroupSlideImageForm"].clearValidate();
      });
    },
    /**
     * @description: 确认添加图片
     * @param {*}
     * @return {*}
     */
    createPitcure() {
      this.$refs["forumGroupSlideImageForm"].validate(async (valid) => {
        if (valid) {
          this.uploadLoading = true;
          let savepathParamsRes = await getOSSUploadInfo({
            DataType: "26",
            ID: "0",
          });
          if (!isVaild(savepathParamsRes)) {
            this.uploadLoading = false;
            return;
          }
          let savePathParams = savepathParamsRes.resultData

          //上传封面
          if (isVaild(this.uploadCoverFile)) {
            // printObj(this.uploadCoverFile.raw)
            let timestamp = new Date().valueOf();

            let uploadRes;
            let fileName;
            if (isVaild(this.uploadCoverFile)) {
              fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
              // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
              uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
                type: this.uploadCoverFile.raw.type
              }), fileName)
            }
            if (uploadRes.status === 0) {
              this.temp.imageUrl = "/" + fileName
              // console.log(this.form.liveCover)
            } else {
              this.$message({
                type: "error",
                message: "上传失败"
              })
            }
            this.$refs.uploadCoverRef.clearFiles();
          }

          const params = deepClone(this.temp);
          addForumGroupSliderImage(params).then((res) => {
            handleRes(res, () => {
              this.refreshCurrentList()
            })
            this.dialogVisible = false
            this.uploadLoading = false;
          });
        } else {
          this.$message({
            type: "error",
            message: "请完善数据",
          });
        }
      });
    },
    /**
     * @description: 打开更新直播轮播对话框
     * @param {*} index
     * @param {*} row
     * @return {*}
     */
    handleUpdate(row) {
      // this.temp = Object.assign({}, row);
      // this.dialogStatus = "update";
      // this.dialogVisible = true;
      // this.$nextTick(() => {
      //   this.$refs["forumGroupSlideImageForm"].clearValidate();
      // });
      go2ForumGroupSlideImageDetail(this, row.forumGroupSliderImageId)
    },
    /**
     * @description: 确认更新直播轮播
     * @param {*}
     * @return {*}
     */
    updatePitcure() {
      this.$refs["forumGroupSlideImageForm"].validate((valid) => {
        if (valid) {
          console.log("success");
          // TODO
          this.creditRuleDialog = false;
          this.refreshCurrentList();
        } else {
          this.$message({
            type: "error",
            message: "请完善数据",
          });
        }
      });
    },
    /**
     *
     */
    handleRemove(row) {
      let tips = row.isDeleted ? '恢复' : '删除'
      this.$confirm(`是否${tips}该轮播图`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
          .then(() => {
            const params = {
              forumGroupSliderImageId: row.forumGroupSliderImageId,
            };
            deleteForumGroupSliderImageOrBack(params).then((res) => {
              handleRes(res, () => {
                this.$message({
                  type: "success",
                  message: `${tips}成功`,
                });
                this.getForumGroupSlideImageList();
              })
            });
          })
          .catch(() => {
            this.$message("取消操作");
          });
    },
    /**
     *
     */
    handlePreview(file) {
      console.log(file);
    },
  },
};
</script>

<style>
</style>